import(/* webpackMode: "eager" */ "/builds/raabe/raabe-de/raabe-portal/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressView"] */ "/builds/raabe/raabe-de/raabe-portal/frontend/src/views/progress.view.tsx");
